import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const ServicesPage = () => {
  const services = [
    {
      title: "Trauma-Informed Care",
      description: "Professional psychological support designed to help survivors process trauma and begin their healing journey.",
      image: "trauma.png",
      details: "Our trauma-informed care approach recognizes the widespread impact of trauma and understands potential paths for recovery. We provide compassionate, evidence-based support that prioritizes safety, trustworthiness, and empowerment."
    },
    {
      title: "Counseling Services",
      description: "One-on-one and group counseling sessions to provide emotional support and guidance.",
      image: "counseling.png",
      details: "Professional counseling services tailored to individual needs, offering a safe space for healing, growth, and emotional well-being. Our trained counselors work with clients to develop coping strategies and build resilience."
    },
    {
      title: "Peer Support Groups",
      description: "Safe spaces where survivors can connect, share experiences, and support each other's recovery.",
      image: "peer.png",
      details: "Community-based support groups that bring together individuals with shared experiences. These groups provide mutual support, reduce isolation, and foster healing through shared understanding and collective strength."
    },
    {
      title: "Community Advocacy",
      description: "Working to reduce stigma and promote understanding of mental health in our communities.",
      image: "community_aware.png",
      details: "We engage with communities to raise awareness about mental health, challenge stigma, and advocate for policies and practices that support survivors and promote psychological well-being for all."
    }
  ];

  return (
    <div className="services-page">
      <div className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <div className="page-badge">What We Offer</div>
            <h1 className="page-title-animated">Our Services</h1>
            <p className="page-subtitle">
              Comprehensive support for healing and empowerment
            </p>
          </div>
        </div>
      </div>

      <div className="container page-content">
        <section className="services-intro">
          <div className="overview-content">
            <h2 className="overview-title">Supporting Your Journey to Healing</h2>
            <div className="overview-text">
              <p>
                At CAEI, we provide a range of professional services designed to support individuals affected by trauma and violence. Our holistic approach addresses both immediate needs and long-term recovery, ensuring that every person receives compassionate, culturally-sensitive care.
              </p>
              <p className="highlight-text">
                All our services are provided with respect, confidentiality, and a commitment to empowering individuals on their path to healing and recovery.
              </p>
            </div>
          </div>
        </section>

        <section className="services-detailed">
          <div className="services-grid-detailed">
            {services.map((service, index) => (
              <div className="service-card-detailed" key={index}>
                <div className="service-image-large" style={{backgroundImage: `url('${service.image}')`}}></div>
                <div className="service-content-detailed">
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <p className="service-details">{service.details}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Working Hours */}
        <section className="working-hours-section">
          <div className="working-hours-card">
            <div className="working-hours-header">
              <div className="hours-icon">🕐</div>
              <h3>Working Hours</h3>
            </div>
            <div className="working-hours-list">
              <div className="hours-item">
                <div className="hours-days">Monday — Thursday</div>
                <div className="hours-time">08:00 AM — 04:00 PM</div>
              </div>
              <div className="hours-item">
                <div className="hours-days">Friday</div>
                <div className="hours-time">08:00 AM — 01:00 PM</div>
              </div>
              <div className="hours-item closed">
                <div className="hours-days">Saturday — Sunday</div>
                <div className="hours-time">CLOSED</div>
              </div>
            </div>
          </div>
        </section>

        <div className="page-nav-footer">
          <Link to="/" className="btn btn-primary">← Back to Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
